// src/components/theme/TimePicker/index.js

import React, { Component } from 'react'
import { withStyles, FormHelperText } from '@material-ui/core'

const styles = theme => ({
  dateTimePickerLabel: {
    display: 'block',
    fontSize: '11.5px',
    lineHeight: '11px',
    backgroundColor: '#fff',
    marginTop: '-11px',
    // marginLeft: '40px',
    textAlign: 'left',
    position: 'absolute',
    zIndex: 1,
    padding: '0 5px',
  },
})

class TimePicker extends Component {
  constructor(props) {
    super(props)

    const date = props.value

    if (date) {
      let hours = date.getHours()
      const minutes = date.getMinutes()

      const isAm = hours < 12
      if (!isAm) {
        hours -= 12
      }
      if (hours === 0) {
        hours = 12
      }

      this.state = {
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        isAm,
      }
    } else {
      this.state = {
        hours: '--',
        minutes: '--',
        isAm: true,
      }
    }
  }

  handleHourChange = e => {
    this.setState({ hours: e.target.value }, this.notifyChange)
  }

  handleMinuteChange = e => {
    this.setState({ minutes: e.target.value }, this.notifyChange)
  }

  toggleAmPm = () => {
    this.setState(prevState => ({ isAm: !prevState.isAm }), this.notifyChange)
  }

  notifyChange = () => {
    let { hours, minutes, isAm } = this.state

    if (hours !== '--' && minutes !== '--') {
      hours = parseInt(hours, 10)
      hours = isAm ? hours % 12 : (hours % 12) + 12

      // Create a new Date object set to today's date
      const newDate = new Date()
      // Set the time in the user's local timezone
      newDate.setHours(hours, parseInt(minutes, 10), 0, 0)

      this.props.handleChange('time', newDate)
    }
  }

  render() {
    const hourOptions = []
    for (let i = 1; i <= 12; i++) {
      hourOptions.push(
        <option key={i} value={i.toString().padStart(2, '0')}>
          {i.toString().padStart(2, '0')}
        </option>,
      )
    }

    const minuteOptions = []
    for (let i = 0; i < 60; i++) {
      minuteOptions.push(
        <option key={i} value={i.toString().padStart(2, '0')}>
          {i.toString().padStart(2, '0')}
        </option>,
      )
    }

    const timeZoneMap = {
      'America/New_York': 'Eastern Time',
      'America/Chicago': 'Central Time',
      'America/Denver': 'Mountain Time',
      'America/Los_Angeles': 'Pacific Time',
      'America/Anchorage': 'Alaska Time',
      'Pacific/Honolulu': 'Hawaii Time',
      'Europe/London': 'British Time',
      'Europe/Paris': 'Central European Time',
      // Add more as needed
    }

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    return (
      <div
        style={{
          ...(this.props.style || {}),
          position: 'relative',
          paddingTop: 11,
        }}
      >
        <div
          style={
            this.props.error ? { color: '#f44336' } : { color: '#0000008A' }
          }
          className={this.props.classes.dateTimePickerLabel}
        >
          {this.props.title} - {timeZoneMap[timeZone] || timeZone}
        </div>
        <select
          style={{
            padding: 10,
            borderRadius: 18,
            marginRight: 2.5,
            border: this.props.error
              ? '1px solid #f44336'
              : '1px solid rgba(0,0,0,0.23)',
          }}
          value={this.state.hours}
          onChange={this.handleHourChange}
        >
          <option value="--" disabled>
            --
          </option>
          {hourOptions}
        </select>
        :
        <select
          style={{
            padding: 10,
            borderRadius: 18,
            marginRight: 5,
            marginLeft: 2.5,
            border: this.props.error
              ? '1px solid #f44336'
              : '1px solid rgba(0,0,0,0.23)',
          }}
          value={this.state.minutes}
          onChange={this.handleMinuteChange}
        >
          <option value="--" disabled>
            --
          </option>
          {minuteOptions}
        </select>
        <div
          style={{
            display: 'inline-block',
            backgroundColor:
              this.props.disabled || this.props.error ? 'b5b5b5' : '#014c94',
            color: this.props.disabled || this.props.error ? '#000' : '#fff',
            padding: 10,
            fontWeight: 'bold',
            borderRadius: 18,
            cursor: 'pointer',
          }}
          onClick={this.toggleAmPm}
        >
          {this.state.isAm ? 'AM' : 'PM'}
        </div>
        {this.props.noHelperText ? null : (
          <FormHelperText error={Boolean(this.props.error)}>
            {this.props.error || this.props.helperText}
          </FormHelperText>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(TimePicker)
